import _ from 'lodash'
import * as T from './types'

const getters = {
    [T.DYNAMIC_TITLE](state) {
        return _.get(state.meta, 'body.header.hide', false)
    },

    [T.CURRENT_META](state) {
        return state.confMeta || {}
    },

    [T.CURRENT_ICON_CSS_URL](state, getter) {
        const link = _.get(getter, `${T.CURRENT_META}.assets.icon`)
        return link || ''
    },

    [T.COMPONENT_INFO_CACHE](state) {
        return state.componentInfoCache
    },

    [T.GET_DYNAMIC_META](state) {
        return state.dynamicMeta
    },
}

export default getters
